export function getUrlParams(): URLSearchParams {
    const hash = window.location.hash;
    const queryString = hash.includes('?') ? hash.slice(hash.indexOf('?') + 1) : '';
    return new URLSearchParams(queryString);
}

export function getAgentSourceType(fallback = 'ip_drafting'): string {
    const agent = getUrlParams().get('agent');
    return agent ? `ip_drafting_${agent}` : fallback;
}
